<section class="multi-messages">
  <h3 class="heading" i18n="@@marketplace.memberDetail.news">Nachrichten</h3>
  <div
    class="form-group span-12 information-text information-text--messages-without-limit"
    i18n="@@employment.conversation.sendMessagesWithoutLimit"
    >Sie haben die Möglichkeit, uneingeschränkt Nachrichten auszutauschen. Mit dem Schreiben der Nachrichten wird Ihr
        Profil <b>nicht</b> automatisch geteilt. Wenn Sie Nachrichten erhalten haben, werden Sie einmal pro Tag via
        E-Mail darüber informiert.
    </div>
  <div class="multi-messages__input-area">
    <app-spinner [visible]="(isLoading$ | async) !== false" class="multi-messages__loading loading"
    size="40"></app-spinner>

    <form (submit)="$event.preventDefault(); request()">
      <div class="multi-messages__input-box">
        <textarea #replyControl
          [formControl]="replyFormControl"
          aria-label="Nachricht verfassen (max 320 Zeichen)…"
          class="multi-messages__textarea textarea"
          i18n-aria-label="@@employment.conversation.placeholderInputMessage"
          i18n-placeholder="@@employment.conversation.placeholderInputMessage"
          maxlength="320"
          placeholder="Nachricht verfassen (max 320 Zeichen)…"
          rows="4"
        ></textarea>

        @if (replyFormControl.invalid && replyFormControl.touched) {
          <div class="validation error"
            i18n="@@employment.conversation.messageError">
                    Bitte geben Sie eine Nachricht ein.
                </div>
        }

        <div class="multi-messages__actions actions">
          <button [disabled]="(isLoading$ | async) !== false" class="button secondary" type="submit">
            <span aria-hidden="true" class="icon icon-send"></span>
            <ng-container i18n="@@employment.conversation.btnSendMessage">Nachricht senden</ng-container>
          </button>
        </div>
      </div>
    </form>
  </div>

  <div class="multi-messages__container">
    <span class="sr-only" i18n="sr-only@@employment.conversation.messageHistory">Nachrichtenverlauf:</span>

    <ol>
      @for (message of messages; track message) {
        <li
          [class]="{ received: message.messageType === RECEIVED, sent: message.messageType === SENT}">
          <app-message
            [companionName]="companionName"
            [messageType]="message.messageType.toLowerCase()"
            [timestamp]="message.createdOn"
            >{{ message.data.text }}
          </app-message>
        </li>
      }
    </ol>

  </div>
</section>
